package com.bikompanion.domain

/**
 * How far from a dock the ground still counts as served, in degrees of latitude.
 *
 * About 450 m — near enough to how far anyone will walk to a bike, which is what makes the
 * circle an honest claim that the ground inside it is served. Wider would start covering the
 * far side of a hill; narrower would break a dense network into disconnected spots.
 */
const val COVERAGE_RADIUS_DEGREES = 0.004

/**
 * One dock's walking distance, as a point on the ground.
 *
 * A point rather than a shape because the shape is the same everywhere: a circle of
 * [COVERAGE_RADIUS_DEGREES] around it, which the map draws at whatever size the current zoom
 * makes that.
 */
data class CoveragePoint(
    val latitude: Double,
    val longitude: Double,
) {
    /**
     * Whether this dock's circle reaches into [box].
     *
     * Squares off the circle — a corner of the box within the radius in both axes counts as a
     * hit even when the true distance is up to 40% further. Being slightly generous here only
     * ever polls a network a moment early, while being tight would drop one that is genuinely
     * on screen.
     */
    fun reaches(box: BoundingBox): Boolean =
        latitude >= box.south - COVERAGE_RADIUS_DEGREES &&
            latitude <= box.north + COVERAGE_RADIUS_DEGREES &&
            longitude >= box.west - COVERAGE_RADIUS_DEGREES &&
            longitude <= box.east + COVERAGE_RADIUS_DEGREES
}
